import { Component } from '@angular/core';

@Component({
  selector: 'app-phloading-lista',
  template: `
    <div class="row" *ngFor="let number of [0,1,2,3,4,5]">
      <div class="col-md-12">
        <div class="ph-item" style="padding: 20px 15px 0px;margin-bottom:15px">
          <div class="ph-col-12">
            <div class="ph-row">
              <div class="ph-col-8"></div>
              <div class="ph-col-2 empty"></div>
              <div class="ph-col-2"></div>
              <div class="ph-col-6"></div>
              <div class="ph-col-4 empty"></div>
              <div class="ph-col-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    `
})
export class PhLoadingListaComponent {
  constructor() { }

}